module.exports = __webpack_public_path__ + "4-86.jpg?2bdd2f19b0b39807c8e98cac622eadd1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4-86.jpg
// module id = 167
// module chunks = 0